export default "__VITE_ASSET__9889cb22__"